import "./SecurityMonitoring.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHero from "./sections/ServiceHero";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function SecurityMonitoringPage() {
  return <div>
      <Header />
      <ServiceHero />
      <Services />
      <Footer />
    </div>;
}